module.exports = __webpack_public_path__ + "img/2_goje.e13ef935.jpg";